import axios from 'axios'
import Vue from 'vue'
export default {
  state: {},
  getters: {},
  actions: {
    uploadReport (ctx, data) {
      return new Promise(() => {
        axios.post('reports/upload', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          type: data.type
        }).then(response => {
          if (response.data.result === 'error') {
            Vue.$toast.error(response.data.message)
          } else {
            let link = document.createElement('a')
            link.href = response.data.data.link
            link.setAttribute('download', response.data.data.name)
            document.body.appendChild(link)
            link.click()
            link.remove()
            Vue.$toast.success(response.data.message)
          }
        }).catch(error => {
          console.log(error)
        })
      })
    },
    getReport (ctx, data) {
      return new Promise((resolve) => {
        axios.post('reports/get', {
          dateFrom: data.dateFrom,
          dateTo: data.dateTo,
          type: data.type
        }).then(response => {
          resolve(response)
          if (response.data.result === 'error') {
            Vue.$toast.error(response.data.message)
          } else {
            Vue.$toast.success(response.data.message)
          }
        }).catch(error => {
          console.log(error)
        })
      })
    }
  },
  mutations: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/reports.js